import React from "react";
import { DataGrid, esES, GridSearchIcon } from "@mui/x-data-grid";
import SnackbarAlert from "./SnackbarAlert";
import useToken from "../useToken";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";

class TablaPanelAuditorias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: useToken.getUser(),
      selectedRow: null,
      pageSize: 25
    };
  }

  render() {
    const columns = [
      { field: "centro", headerName: "Centro", flex: 1, minWidth: 100 },
      { field: "mes", headerName: "Mes", flex: 1, minWidth: 110 },
      {
        field: "num_aud",
        headerName: "N°Aud",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "total_cajas",
        headerName: "Total Cajas",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "cajas_error",
        headerName: "Cajas Error",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_error_cajas",
        headerName: "Error Cajas (%)",
        flex: 1,
        minWidth: 120,
        // Quitamos el valueGetter para el ordenamiento porque ahora lo hace el servidor
        renderCell: (params) => {
          if (params.value == null) return null;
          let color = params.value >= 5 ? "error" : "success";

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>{params.value}%</div>
              <LinearProgress variant="determinate" value={params.value} color={color} sx={{ height: 8, borderRadius: 4 }} />
            </div>
          );
        }
      },
      {
        field: "total_unidades",
        headerName: "Total Un.",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "dif_cantidad",
        headerName: "Error Un.",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_error_unidades",
        headerName: "Error Un.(%)",
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
          if (params.value == null) return null;
          let color = params.value >= 5 ? "error" : "success";

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>{params.value}%</div>
              <LinearProgress variant="determinate" value={params.value} color={color} sx={{ height: 8, borderRadius: 4 }} />
            </div>
          );
        }
      },
      {
        field: "total_monto",
        headerName: "Total Monto",
        flex: 1,
        minWidth: 130,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "dif_monto",
        headerName: "Error Monto",
        flex: 1,
        minWidth: 130,
        type: "number",
        valueFormatter: (params) => new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_error_monto",
        headerName: "Error Monto (%)",
        flex: 1,
        minWidth: 130,
        renderCell: (params) => {
          if (params.value == null) return null;
          let color = params.value >= 5 ? "error" : "success";

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>{params.value}%</div>
              <LinearProgress variant="determinate" value={params.value} color={color} sx={{ height: 8, borderRadius: 4 }} />
            </div>
          );
        }
      },
      {
        field: "acciones",
        headerName: "Acciones",
        minWidth: 100,
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          const rowData = params.row;
          return (
            <div style={{ display: "flex", gap: 8 }}>
              <Tooltip title="Ver detalle">
                <Link to={`/panel_auditorias_altillo/${rowData.centro}/${rowData.mes}`}>
                  <GridSearchIcon />
                </Link>
              </Tooltip>
            </div>
          );
        }
      }
    ];

    return (
      <div style={{ height: '100%', width: "100%" }}>
        <DataGrid
          rows={this.props.disponibles}
          disableColumnMenu
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rowCount={this.props.total ?? 0}
          sortingOrder={['asc', 'desc']}
          sortingMode="server" 
          onSortModelChange={this.props.onSortChange} 
          paginationMode="server"
          paginationModel={this.props.paginationModel}
          pageSizeOptions={[10, 25, 50]}
          onPaginationModelChange={this.props.onPageChange}
          onRowClick={(params) => this.setState({ selectedRow: params.id })}
          getRowClassName={(params) => (this.state.selectedRow === params.id ? "row-selected" : "")}
          getRowId={(row) => `${row.centro}-${row.mes}`}
        />
          <style>
          {`
            .row-selected { background-color: #dbe9fc !important; }
          `}
        </style>
      </div>
    );
  }
}

export default TablaPanelAuditorias;